import React, { useEffect } from 'react';
import Loader from '../Shared/Loader/loader';
import { getTenantsByProjectId } from '../../API/Tenant/Tenant';
import { usePropsStoreValue } from '../../Hooks/PropStore/usePropsStore';
import { useTenantsApp } from '../../Context/TenantsApp/TenantsAppContext';
import { SET_LOADING, SET_PROJECT, SET_TENANTS } from './TenantsAppEvents';
import TenantsAppGrid from './TenantsAppGrid';
import DeleteTenantApp from './DeleteTenantApp';
import SyncAllTenants from './SyncAllTenants';
import SyncAllTenantsDialog from './SyncAllTenantsDialog';
import SyncTenantDialog from './SyncTenantDialog';
import { getProject } from '../../API/Project/project';
import DisableTenantApp from './DisableTenantApp';


const SyncTenants = () => {
    const project = usePropsStoreValue('project');
    const { state, dispatch } = useTenantsApp();
    useEffect(() => {
        const fetchTenants = async () => {
            try {
                let [tenants, masterProject] = await Promise.all([
                    getTenantsByProjectId(project._id),
                    getProject(project._id)
                ]);
                dispatch({ type: SET_PROJECT, payload: masterProject });
                dispatch({ type: SET_TENANTS, payload: tenants });
            } catch (error) {
                console.error('Error fetching tenants:', error);
            } finally {
                dispatch({ type: SET_LOADING, payload: false });
            }
        };
        fetchTenants();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (state.loading) return <Loader />;

    return (

        <div className='mt-3 row'>
            <div className='col-12 mb-3'>
                <SyncAllTenants />
            </div>
            <div className='col-12'>
                {state.showDeleteAppDialog && <DeleteTenantApp />}
                {state.showDisableAppDialog && <DisableTenantApp />}
                {state.showSycnAllTenantsDialog && <SyncAllTenantsDialog />}
                {state.showSyncTenantDialog && <SyncTenantDialog />}
                <TenantsAppGrid />
            </div>
        </div>
    );
}

export default SyncTenants;